import React, { lazy } from 'react'

const AccessSecurityDigitalReportSubmenu = lazy(() =>
  import('./AccessSecurityReportSubmenu').then(module => ({
    default: module.AccessSecurityDigitalReportSubmenu,
  }))
)

const AccessRolesReport = lazy(() =>
  import('./AccessRolesReport').then(module => ({
    default: module.AccessRolesListingReport,
  }))
)

const UserListingReport = lazy(() =>
  import('./UserListingReport').then(module => ({
    default: module.UserListingReport,
  }))
)

const AccessRolesReportParameter = lazy(() =>
  import('./AccessRolesReportParameter').then(module => ({
    default: module.AccessRolesReportParameter,
  }))
)

const UserLoginLogParamsForm = lazy(() =>
  import(
    '@account-root/account-react/src/containers/GeneralLedgerModule/GLDigitalReportModule/Parameters/UserLoginLogParamsForm'
  ).then(module => ({
    default: module.UserLoginLogParamsForm,
  }))
)

const UserLoginLogReport = lazy(() =>
  import(
    '@account-root/account-react/src/containers/GeneralLedgerModule/GLDigitalReportModule/GeneratedReport/UserLoginLogReport'
  ).then(module => ({
    default: module.UserLoginLogReport,
  }))
)

const EntityAccessAuthorizationReportParameter = lazy(() =>
  import('./EntityAccessAuthorizationReportParameter').then(module => ({
    default: module.EntityAccessAuthorizationReportParameter,
  }))
)

const EntityAccessAuthorizationReport = lazy(() =>
  import('./EntityAccessAuthorizationReport').then(module => ({
    default: module.EntityAccessAuthorizationReport,
  }))
)

const accessSecurityDigitalReportingRoutes = [
  {
    props: {
      exact: true,
      path: '/digital-reports/access-security',
    },
    component: <AccessSecurityDigitalReportSubmenu mode="access-security" />,
  },
  {
    props: {
      exact: true,
      path: '/access-security/access-roles-listing-report',
    },
    component: <AccessRolesReportParameter />,
  },
  {
    props: {
      exact: true,
      path: '/access-security/access-roles-listing-report/view',
    },
    component: <AccessRolesReport reportMode="access-roles-listing-report" />,
  },
  {
    props: {
      exact: true,
      path: '/access-security/user-listing-report/view',
    },
    component: <UserListingReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/access-security/user-login-log-report',
    },
    component: (
      <UserLoginLogParamsForm
        submenu="access-security"
        smTitle="Access Security"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/access-security/user-login-log-report/view',
    },
    component: (
      <UserLoginLogReport
        submenu="access-security"
        smTitle="Access Security"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: '/access-security/entity-access-authorization-listing-report',
    },
    component: <EntityAccessAuthorizationReportParameter />,
  },
  {
    props: {
      exact: true,
      path: '/access-security/entity-access-authorization-listing-report/view',
    },
    component: <EntityAccessAuthorizationReport />,
  },
]

export default accessSecurityDigitalReportingRoutes
